import { useQuery, useQueryClient } from "@tanstack/react-query";
import { apiCall } from "../lib/api";
import type { RecordsResponse } from "../lib/types";

/**
 * Orders queue. Mirrors loadAllOrders(): when not "show all" and no explicit
 * range, defaults to the last 8 weeks. The server (api-tpfl /v1/orders/queue)
 * computes daily_order_num, return_status_bucket, return_option_normalized.
 */
export function useRecords(tab: "orders" | "dataEntry", range: { start: string; end: string } | null) {
  return useQuery({
    queryKey: ["records", tab, range?.start ?? "", range?.end ?? ""],
    queryFn: () => {
      let url = `records?tab=${tab}`;
      if (range && range.start && range.end) url += `&dateRange=${range.start},${range.end}`;
      return apiCall<RecordsResponse>(url);
    },
  });
}

/** Incomplete orders for the Data Entry tab (tab=data-entry, optional single date). */
export function useDataEntry(date: string, enabled: boolean) {
  return useQuery({
    queryKey: ["records", "data-entry", date],
    queryFn: () => {
      let url = "records?tab=data-entry";
      if (date) url += `&date=${date}`;
      return apiCall<RecordsResponse>(url);
    },
    enabled,
  });
}

export function useRefreshCounts() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ["counts"] });
}
